(function() { window.GUID_b479580c_e64d_4c3e_824d_95c0fa737501 = { getGuid: function() { return "b479580c-e64d-4c3e-824d-95c0fa737501"; } }; })();
CompuSport.DOM.body.on('click', '.SetWinner', function (e) {
    var data = {
        elementToRefresh: 'ScheduleItem',
        encounterRowId: $(this).data('encounterrowid')
    };
    ShowSchedulesScorePopup(data);
});
function ShowSchedulesScorePopup(data) {
    CompuSport.Ajax.Get(CSParameters.RUrl + 'Scores/CheckIsNewScoreSheet/' + CSParameters.SportEventId, data, function (response) {
        if (response.isNewScoreSheet) {
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: 'ScorePopup',
                Url: CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (response) {
                //UpdateChart(response, true);
            };
        }
        else {
            /*
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "ScorePopup",
                Url: CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (response) {
                UpdateChart(response, true);
            }
            */
            ShowFormPopup(CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId, data, null, function (response, pressedButton) {
                if (pressedButton != "EnterKey") {
                    //UpdateChart(response, true);
                    $(this).dialog('close');
                }
            });
        }
    });
}

//# sourceMappingURL=Schedules.js.map
